import { Message } from '@baseai/core';
import { PromptForm } from './prompt-form';
import { Button } from '@/components/ui/button';
import { IconRegenerate, IconStop } from './icons';
import { CustomStylesI } from './index';

export function ChatInput({
	isLoading,
	stop,
	regenerate,
	input,
	setInput,
	messages,
	onSubmit,
	reset,
	customStyles
}: {
	isLoading: boolean;
	stop: () => void;
	regenerate: () => void;
	input: string;
	setInput: (
		e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => void;
	messages: Message[];
	onSubmit: (e: React.FormEvent<HTMLFormElement>) => Promise<void>;
	reset: () => void;
	customStyles?: CustomStylesI;
}) {
	return (
		<div className="lb-fixed lb-inset-x-0 lb-bottom-0 lb-px-4">
			<div className="lb-mx-auto lb-max-w-3xl sm:lb-max-w-4xl">
				<div className="lb-flex lb-h-10 lb-items-center lb-justify-center">
					{isLoading ? (
						<Button
							variant="outline"
							onClick={stop}
							className="lb-bg-background lb-text-muted-foreground"
							size={'sm'}
						>
							<IconStop className="lb-text-muted-foreground/50 group-hover:lb-text-background" />
							Stop generating
						</Button>
					) : (
						messages?.length > 0 && (
							<Button
								variant="outline"
								onClick={regenerate}
								className="lb-bg-background lb-text-muted-foreground"
								size={'sm'}
							>
								<IconRegenerate className="lb-size-4 lb-text-muted-foreground/50 group-hover:lb-text-background" />
								Regenerate response
							</Button>
						)
					)}
				</div>
				<div className="lb-space-y-2 lb-pb-4 lb-pt-2">
					<PromptForm
						input={input}
						onSubmit={onSubmit}
						setInput={setInput}
						isLoading={isLoading}
						reset={reset}
						customStyles={customStyles}
					/>
					<div className="lb-flex lb-items-center lb-justify-center lb-text-xs lb-text-muted-foreground/80">
						Powered by{' '}
						<a
							className="lb-ml-1 lb-font-bold lb-text-muted-foreground/80 lb-transition-colors hover:lb-text-primary/80"
							href="https://langbase.com/"
							target="_blank"
						>
							⌘ Langbase
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}
